<template>
  <div class="airST-conditional-card" v-bind="$attrs">
    <div v-if="title" class="airST-conditional-title">{{ title }}</div>
    <!-- use slot to place content of card -->
    <div class="airST-conditional-contents">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TkFilterConditionCard',
  props: {
    title: {
      type: String,
      default: null,
    },
  },
}
</script>
